import LegalPageContent from '../components/legal/LegalPageContent';

const LegalPage = () => {
  return <LegalPageContent />;
};

export default LegalPage;